(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  const BREAKPOINT = 989;

  const getDrawerContainer = () =>
    document.getElementById('Details-menu-drawer-container');

  const getDrawer = () => document.getElementById('menu-drawer');

  const keepDrawerOpen = () => {
    const container = getDrawerContainer();
    const drawer = getDrawer();

    if (!container || !drawer) return;

    container.open = true;
    container.classList.add('menu-opening');
    drawer.style.transform = 'translateX(0)';
    drawer.style.visibility = 'visible';
  };

  const closeOtherPanels = (currentButton) => {
    document.querySelectorAll(
      '.menu-drawer__submenu-toggle[aria-expanded="true"]'
    ).forEach((button) => {
      if (button === currentButton) return;

      const panel = document.getElementById(
        button.getAttribute('aria-controls')
      );

      button.setAttribute('aria-expanded', 'false');

      if (panel) panel.hidden = true;
    });
  };

  const togglePanel = (button) => {
    const panel = document.getElementById(
      button.getAttribute('aria-controls')
    );

    if (!panel) return;

    const isOpen = button.getAttribute('aria-expanded') === 'true';

    closeOtherPanels(button);

    button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    panel.hidden = isOpen;

    if (!isOpen) {
      keepDrawerOpen();
      requestAnimationFrame(keepDrawerOpen);
      setTimeout(keepDrawerOpen, 0);
    }
  };

  const initMobileDrawerMenus = () => {
    if (window.innerWidth > BREAKPOINT) return;

    const container = getDrawerContainer();

    // Arrow click
    document.querySelectorAll('.menu-drawer__submenu-toggle').forEach((button) => {
      if (button.dataset.mobileDrawerReady === 'true') return;

      button.dataset.mobileDrawerReady = 'true';

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        togglePanel(button);
      }, true);
    });

    // Menu text click
    document.querySelectorAll(
      '.menu-drawer__expandable-row .menu-drawer__menu-link'
    ).forEach((link) => {
      if (link.dataset.mobileTextReady === 'true') return;

      link.dataset.mobileTextReady = 'true';

      link.addEventListener('click', (event) => {
        if (window.innerWidth > BREAKPOINT) return;

        event.preventDefault();
        event.stopPropagation();

        const row = link.closest('.menu-drawer__expandable-row');
        const button = row?.querySelector('.menu-drawer__submenu-toggle');

        if (button) togglePanel(button);
      });
    });

    // Keep the main drawer open when a submenu is expanded
    if (container && container.dataset.mobileDrawerToggleReady !== 'true') {
      container.dataset.mobileDrawerToggleReady = 'true';

      container.addEventListener('toggle', () => {
        if (window.innerWidth > BREAKPOINT) return;

        const openPanel = container.querySelector(
          '.menu-drawer__submenu-toggle[aria-expanded="true"]'
        );

        if (openPanel && !container.open) {
          keepDrawerOpen();
        }
      });
    }
  };

  const resetMobilePanels = () => {
    document.querySelectorAll('.menu-drawer__submenu-toggle').forEach((button) => {
      const panel = document.getElementById(
        button.getAttribute('aria-controls')
      );

      button.setAttribute('aria-expanded', 'false');

      if (panel) panel.hidden = true;
    });
  };

  initMobileDrawerMenus();

  document.addEventListener('shopify:section:load', initMobileDrawerMenus);

  window.addEventListener('resize', () => {
    if (window.innerWidth > BREAKPOINT) {
      resetMobilePanels();
    } else {
      initMobileDrawerMenus();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
